import React, { useState, useEffect, memo, useCallback, useMemo } from "react";
import { TouchableOpacity } from "react-native";
import styled, { useTheme } from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBText, CheckBox, Spacer } from "@components/atoms";
import { CustomTopTabsProps } from "./types";
import { DEVICE_SIZE } from "@utils/index";
import { Platform } from "react-native";
import { Menu, MenuItem, MenuItemLabel } from "@gluestack-ui/themed";
import { Pressable } from "react-native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import RenderHTML from "react-native-render-html";
import Routes from "@navigations/Routes";
import { useFocusEffect } from "@react-navigation/native";
import { navigate } from "@navigations/utils/RootNavigation";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getDrawerWidth } from "@navigations/utils/constants";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useJoyride } from "@components/atoms/Joyride";
import ListViewSkeleton from "@scenes/searchResults/components/ListViewSkeleton";
import { useHeaderBulkOption } from "../../../hooks/useHeaderBulkOption";
import BulkActionsContent from "@scenes/searchResults/BulkActionsContent";
import WebActionButton from "@components/atoms/WebActionButton/WebActionButton";
import Tooltip from "@components/atoms/Tooltip";
import { useProductPrefix } from "../../../hooks/useProductPrefix";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { normalizeBoolean } from "@components/atoms/Filters/ButtonSection/Utils";
import { useSearchFiltersAuxPayload } from "@redux/slices/searchFilters";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";
import { BulkActions, BulkTasks } from "@utils/product/menuBuilders";
import { ProductCategory } from "@utils/constants";
import { RootState } from "@redux/store";
import { DefaultTheme } from "styled-components/native";
import { VDBIcons } from "@utils/VDBIcons";

const menuItemIconName = (viewType: string) => {
  switch (viewType) {
    case SearchResultsAndFavoritesEnum.GRID:
      return "grid";
    case SearchResultsAndFavoritesEnum.LIST:
      return "list";
    case SearchResultsAndFavoritesEnum.LIST_EXPANDED:
      return "list-expanded";
    case SearchResultsAndFavoritesEnum.VIDEO_ONLY:
      return "video";
    default:
      return "grid";
  }
};

const CustomTopTabsWeb = ({
  productArray,
  handleCardClick,
  flatListBackgroundColor,
  menuOptions,
  defaultViewType,
  selectViewType,
  menuItemEventName,
  sortingFiltersParams,
  showDotOnFilter,
  masterCheckBoxSelection,
  masterCheckboxSelected,
  selectAllText,
  deSelectAllText,
  isFilterVisible,
  productType,
  totalItems,
  skipFilterScreenForWeb,
  isFilterApplied,
  selectedItems,
  selectOption,
  isloading,
  enterSecondFlow,
  showChangeViewMenu,
  sectionName,
  showSortingOption,
}: CustomTopTabsProps) => {
  const mEnterSecondFlow = normalizeBoolean(enterSecondFlow);
  const safeKey = (value: unknown) =>
    String(value ?? "item")
      .replace(/\\s+/g, "_")
      .replace(/[^a-zA-Z0-9._-]/g, "");
  const baseTestId = "customTopTabsWeb";
  const theme = useTheme();
  const { enableJewelryBuilder } = useOrgSettingsSlice();
  const isTablet = theme.isTablet;
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const { deviceWidth: windowWidth } = useIsFoldable();
  const drawerWidth = getDrawerWidth(windowWidth, theme);
  const userInfo = useUserInfo();
  const productPrefix = useProductPrefix();
  const [selectedViewType, setSelectedViewType] = useState(defaultViewType);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [internalProductArray, setInternalProductArray] =
    useState(productArray);
  const { navigateBack } = useNavigationHistory();
  const payload = useSearchFiltersAuxPayload();
  const priceMode = userInfo?.user?.price_mode;
  const { showBulkRequestFeature } = useUserInfo();
  let { bulkActions } = useHeaderBulkOption(
    productType as ProductCategory,
    priceMode,
    t
  );
  const isMyInventory =
    userInfo.enableSellReturnButton() &&
    (payload[sectionName]?.with_available_items === "true" ||
      payload[sectionName]?.with_available_items === true);

  if (bulkActions === null) {
    bulkActions = BulkActions(
      t,
      showBulkRequestFeature(productType as ProductCategory, priceMode)
    );
  }

  const isConfigurableJewelry = (item: any) =>
    item?.custom_design_configuration === true &&
    item?.display_configuration_v2 &&
    Array.isArray(item?.display_configuration_v2) &&
    item?.display_configuration_v2?.length > 0;

  const allSelectedAreConfigurable =
    selectedItems.length > 1 &&
    selectedItems.every((item) => isConfigurableJewelry(item));

  if (allSelectedAreConfigurable && bulkActions) {
    bulkActions = bulkActions.filter(
      (action: any) =>
        ![
          SearchResultsAndFavoritesEnum.BUY_NOW,
          SearchResultsAndFavoritesEnum.ADD_TO_CART,
        ].includes(action?.name)
    );
  }

  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  const [menuItemOptionIcon, setMenuItemOptionIcon] = useState(
    selectedViewType
      ? menuItemIconName(selectedViewType as string)
      : menuItemIconName(SearchResultsAndFavoritesEnum.GRID)
  );
  const screenWidth =
    isTablet || theme.isDesktop ? DEVICE_SIZE.width * 0.65 : windowWidth;
  const { startTourForScope } = useJoyride() || ({} as any);
  const overlayActiveScreensWeb = useSelector(
    (state: RootState) => state.appState.overlayActiveScreensWeb
  );
  const startTour = () => {
    if (Platform.OS === "web") {
      if (overlayActiveScreensWeb.SearchResult) {
        startTourForScope("SearchResult");
      } else {
      }
    }
  };
  useFocusEffect(
    useCallback(() => {
      if (Platform.OS === "web") {
        if (overlayActiveScreensWeb.SearchResult) {
          startTourForScope("SearchResult");
        } else {
        }
      }
    }, [overlayActiveScreensWeb.SearchResult])
  );
  const internalHandleCardClick = (clickedItem: any) => {
    const updatedProductArray = internalProductArray.map((item: any) =>
      item.id === clickedItem.id
        ? { ...item, selection: true }
        : { ...item, selection: false }
    );
    setInternalProductArray(updatedProductArray);
    handleCardClick(clickedItem);
  };

  useEffect(() => {
    setInternalProductArray(productArray);
  }, [productArray]);

  const goBackButtonPress = () => {
    navigate(
      Routes.FilterScreen,
      {
        productType,
        fromResultScreen: false,
        productPrefix,
        sectionName,
      },
      { merge: true, pop: true }
    );
    navigateBack();
  };

  // const onRemoveFilters = () => {
  //   if (
  //     theme.isMobile &&
  //     (productType === ProductCategory.JEWELRY ||
  //       productType === ProductCategory.LABGROWN_JEWELRY)
  //   ) {
  //     DeviceEventEmitter.emit("RESET_FILTERS_EVENT");
  //     dispatch(resetJewelryFiltersPayload());
  //   } else {
  //     DeviceEventEmitter.emit("RESET_FILTERS_EVENT");
  //     dispatch(resetFiltersPayload());
  //   }
  //   navigate(Routes.FilterScreen, {
  //     productType,
  //     fromResultScreen: false,
  //   });
  // };

  const renderResetAllButton = () =>
    (enableJewelryBuilder ? mEnterSecondFlow === false : true) && (
      <ResetAllButton onPress={goBackButtonPress}>
        <TabContent>
          <VDBIcon
            color={theme["core-06"]}
            name={"left"}
            size={16}
            variant={IconsVariant.VDBCustom}
          />
          <TabText type={typography["Minor-R"]} color={theme["link-static"]}>
            {t("productDetailPage.goBack.text")}
          </TabText>
        </TabContent>
      </ResetAllButton>
    );

  const bulkButtonText = useMemo(() => {
    return selectedItems.length > 0
      ? `${t("searchResult.bulkActions.button.text")} (${selectedItems.length})`
      : t("searchResult.bulkActions.button.text");
  }, [selectedItems, userInfo.user?.locale]);

  const renderTabItem = (item: any, index: number, isLeftSection: boolean) => {
    const disableState =
      item.eventName === SearchResultsAndFavoritesEnum.CHANGE_VIEW ||
      item.eventName === SearchResultsAndFavoritesEnum.CUSTOM_COLUMN ||
      item.eventName === SearchResultsAndFavoritesEnum.SORTING
        ? !totalItems
        : false;
    if (
      (item.eventName === SearchResultsAndFavoritesEnum.SORTING &&
        selectedViewType === SearchResultsAndFavoritesEnum.LIST) ||
      ((item.eventName === SearchResultsAndFavoritesEnum.SAVE_SEARCH ||
        item.eventName === SearchResultsAndFavoritesEnum.BULK_ACTION) &&
        userInfo.isIFrame()) ||
      (item.eventName === SearchResultsAndFavoritesEnum.CUSTOM_COLUMN &&
        selectedViewType === SearchResultsAndFavoritesEnum.GRID) ||
      (!showChangeViewMenu &&
        item.eventName === SearchResultsAndFavoritesEnum.CHANGE_VIEW) ||
      (!showSortingOption &&
        item.eventName === SearchResultsAndFavoritesEnum.SORTING)
    ) {
      return null;
    }
    const processEventName = () => {
      if (
        item.eventName === SearchResultsAndFavoritesEnum.SORTING ||
        item.eventName === SearchResultsAndFavoritesEnum.CUSTOM_COLUMN
      ) {
        return `${item.eventName}-SearchResult`;
      }
      return item.eventName;
    };

    const itemKey = safeKey(processEventName() || item.id || index);
    const itemTestId = `${baseTestId}.tab.${itemKey}`;
    return (
      <ItemContainer
        key={item.id}
        id={`${processEventName()}`}
        testID={`${itemTestId}.container`}
        data-testId={`${itemTestId}.container`}
      >
        <CardMain
          isFocused={
            !disableState
              ? item?.eventName === menuItemEventName
                ? false
                : item.selection ||
                  (item?.eventName === SearchResultsAndFavoritesEnum.FILTERS &&
                    isFilterVisible)
              : false
          }
          testID={`${itemTestId}.card`}
          data-testId={`${itemTestId}.card`}
        >
          {item?.eventName &&
          menuItemEventName?.includes(item?.eventName) &&
          !disableState ? (
            <>
              {item?.eventName === SearchResultsAndFavoritesEnum.BULK_ACTION ? (
                <Tooltip
                  showOnPress
                  isOpen={tooltipIsOpen}
                  setIsOpen={setTooltipIsOpen}
                  showArrowIcon={false}
                  trigger={() => (
                    <WebActionButton
                      bulkButtonText={bulkButtonText}
                      id="bulkAction-BulkActions"
                    />
                  )}
                  tooltipBackgroundColor={theme["over-01"]}
                  popoverBackdropColor={"transparent"}
                  popoverProps={{ size: "md" }}
                  popoverContentProps={{ marginTop: 24 }}
                  popoverBodyProps={{
                    padding: 0,
                    margin: 0,
                    minWidth: 184,
                    backgroundColor: theme["core-01"],
                  }}
                >
                  <BulkActionsContent
                    itemCount={selectedItems.length ?? 0}
                    totalItems={totalItems}
                    menuOptions={BulkTasks(
                      t,
                      bulkActions,
                      showBulkRequestFeature(productType, priceMode),
                      isMyInventory
                    )}
                    selectOption={(value) => {
                      setTooltipIsOpen(false);
                      selectOption(value);
                    }}
                    noPadding
                    hideArrowIcon
                  />
                </Tooltip>
              ) : (
                <Menu
                  mt={Platform.OS === "ios" ? 10 : -20}
                  py={0}
                  selectionMode={
                    item?.eventName ===
                    SearchResultsAndFavoritesEnum.BULK_ACTION
                      ? "none"
                      : "single"
                  }
                  marginStart={15}
                  marginTop={16}
                  borderRadius={12}
                  placement={
                    internalProductArray?.length === 1
                      ? "bottom"
                      : "bottom left"
                  }
                  testID={`${itemTestId}.menu`}
                  data-testId={`${itemTestId}.menu`}
                  trigger={({ ...triggerProps }) => {
                    const isFocused = triggerProps["aria-expanded"];
                    return (
                      <Pressable
                        {...triggerProps}
                        onHoverIn={() =>
                          setHoveredIndex(isLeftSection ? index : index + 1)
                        }
                        onHoverOut={() => setHoveredIndex(null)}
                        testID={`${itemTestId}.menuTrigger`}
                        data-testId={`${itemTestId}.menuTrigger`}
                      >
                        <CardMainMenu isFocused={isFocused}>
                          <TabContent>
                            <VDBIcon
                              color={
                                !disableState
                                  ? isFocused ||
                                    hoveredIndex ===
                                      (isLeftSection ? index : index + 1)
                                    ? theme["core-05"]
                                    : theme["core-06"]
                                  : theme["core-03"]
                              }
                              name={menuItemOptionIcon}
                              size={24}
                              variant={IconsVariant.VDBCustom}
                            />
                            <TabText
                              type={typography["Minor-R"]}
                              color={
                                !disableState
                                  ? isFocused
                                    ? theme["core-05"]
                                    : theme["core-06"]
                                  : theme["core-03"]
                              }
                            >
                              {item.title}
                            </TabText>
                          </TabContent>
                        </CardMainMenu>
                      </Pressable>
                    );
                  }}
                >
                  {menuOptions &&
                    menuOptions.map((option, _index) => (
                      <MenuItem
                        key={option.name}
                        textValue={option.label}
                        style={{ padding: 0, borderRadius: SpaceType.Basic }}
                        onPress={() => {
                          if (!disableState) {
                            setSelectedViewType(option.name.toString());
                            selectViewType(option.name);
                            setMenuItemOptionIcon(
                              menuItemIconName(option.name.toString())
                            );
                          }
                        }}
                        testID={`${itemTestId}.menuItem.${safeKey(
                          option.name
                        )}`}
                        data-testId={`${itemTestId}.menuItem.${safeKey(
                          option.name
                        )}`}
                      >
                        <MenuItemParentContainer>
                          <MenuItemContainer
                            style={{
                              backgroundColor: theme["core-01"],

                              ...(_index === menuOptions.length - 1 && {
                                borderBottomLeftRadius: SpaceType.Basic,
                                borderBottomRightRadius: SpaceType.Basic,
                              }),
                              ...(_index === 0 && {
                                borderTopLeftRadius: SpaceType.Basic,
                                borderTopRightRadius: SpaceType.Basic,
                              }),
                            }}
                          >
                            <IconLabelWrapper>
                              <VDBIcon
                                color={
                                  selectedViewType === option.name
                                    ? theme["core-05"]
                                    : theme["core-06"]
                                }
                                name={option.icon}
                                size={20}
                                variant={IconsVariant.VDBCustom}
                              />
                              <Spacer size={SpaceType.Basic} />
                              <MenuItemLabel
                                size="sm"
                                color={theme["core-05"]}
                                fontStyle={typography["Minor-M"]}
                              >
                                {option.label}
                              </MenuItemLabel>
                            </IconLabelWrapper>
                            {selectedViewType === option.name && (
                              <CheckIconWrapper
                                testID={`${itemTestId}.menuItem.${safeKey(
                                  option.name
                                )}.check`}
                                data-testId={`${itemTestId}.menuItem.${safeKey(
                                  option.name
                                )}.check`}
                              >
                                <VDBIcon
                                  color={theme["success-01"]}
                                  name="check"
                                  size={16}
                                  variant={IconsVariant.VDBCustom}
                                />
                              </CheckIconWrapper>
                            )}
                          </MenuItemContainer>
                          {_index < menuOptions.length - 1 && (
                            <LineView theme={theme} />
                          )}
                        </MenuItemParentContainer>
                      </MenuItem>
                    ))}
                </Menu>
              )}
            </>
          ) : (
            <Pressable
              onPress={() => internalHandleCardClick(item)}
              onHoverIn={() =>
                setHoveredIndex(isLeftSection ? index : index + 1)
              }
              onHoverOut={() => setHoveredIndex(null)}
              style={[
                theme.isLargeScreen && {
                  padding: 8,
                  margin: -4,
                },
              ]}
              testID={`${itemTestId}.button`}
              data-testId={`${itemTestId}.button`}
            >
              <TabContent>
                <IconContainer>
                  <VDBIcon
                    color={
                      !disableState
                        ? item.selection ||
                          hoveredIndex === (isLeftSection ? index : index + 1)
                          ? theme["core-05"]
                          : theme["core-06"]
                        : theme["core-03"]
                    }
                    name={
                      item?.eventName === SearchResultsAndFavoritesEnum.FILTERS
                        ? isFilterVisible
                          ? VDBIcons.MINIMIZE
                          : VDBIcons.ADD_CIRCLE
                        : item.icon
                    }
                    size={24}
                    variant={IconsVariant.VDBCustom}
                  />
                  {((item?.eventName ===
                    SearchResultsAndFavoritesEnum.SORTING &&
                    sortingFiltersParams &&
                    sortingFiltersParams.length > 0) ||
                    (item?.eventName ===
                      SearchResultsAndFavoritesEnum.FILTERS &&
                      (showDotOnFilter || isFilterApplied))) && (
                    <RedIconContainer theme={theme} />
                  )}
                </IconContainer>
                <TabText
                  type={typography["Body-R"]}
                  color={
                    !disableState
                      ? item.selection
                        ? theme["core-05"]
                        : theme["core-06"]
                      : theme["core-03"]
                  }
                >
                  {item?.eventName === SearchResultsAndFavoritesEnum.FILTERS &&
                  isFilterVisible
                    ? t("searchResult.web.screenOptions.hideFilters.text")
                    : item.title}
                </TabText>
              </TabContent>
            </Pressable>
          )}
        </CardMain>
      </ItemContainer>
    );
  };
  const MasterCheckbox = () => {
    return (!isTablet ||
      (selectedViewType !== SearchResultsAndFavoritesEnum.LIST && isTablet)) &&
      !userInfo.isIFrame() ? (
      <CheckBox
        fillColor={theme["knob-bor"]}
        checkBoxSize={20}
        checkedFunction={masterCheckBoxSelection}
        isChecked={masterCheckboxSelected}
      />
    ) : null;
  };
  const renderCheckboxSection = () =>
    totalItems ? (
      <CheckboxSectionContainer
        testID={`${baseTestId}.checkboxSection`}
        data-testId={`${baseTestId}.checkboxSection`}
      >
        <MasterCheckbox />
        <RenderHTML
          contentWidth={screenWidth}
          source={{
            html: `${masterCheckboxSelected ? deSelectAllText : selectAllText}`,
          }}
          tagsStyles={{
            body: {
              ...typography["Body-R"],
              color: theme["core-06"],
            },
            b: { ...typography["Body-M"], color: theme["core-05"] },
          }}
        />
      </CheckboxSectionContainer>
    ) : (
      <ListViewSkeleton rows={1} />
    );

  return (
    <Container
      backgroundColor={flatListBackgroundColor}
      onLayout={() => startTour()}
    >
      <LeftTabsContainer>
        <LeftWrapper containerWidth={drawerWidth}>
          {(enableJewelryBuilder ? mEnterSecondFlow === false : true) &&
            (!skipFilterScreenForWeb && !isMyInventory ? (
              renderResetAllButton()
            ) : (
              <ResetAllButton />
            ))}
          {isMyInventory ? (
            <VDBText type={typography["H3-M"]} color={theme["core-06"]}>
              {t("searchResult.myInventory.text", "My Inventory")}
            </VDBText>
          ) : (
            internalProductArray
              .slice(0, 1)
              .map((item: any, index: number) =>
                renderTabItem(item, index, true)
              )
          )}
        </LeftWrapper>
        <HorizontalSeparator />
        {(totalItems || isloading) && renderCheckboxSection()}
      </LeftTabsContainer>
      <RightTabsContainer>
        {internalProductArray
          .slice(1)
          .filter((itm: any) => {
            if (
              userInfo.enableSellReturnButton() &&
              (payload[sectionName]?.with_available_items === "true" ||
                payload[sectionName]?.with_available_items === true)
            ) {
              return (
                itm.eventName !== SearchResultsAndFavoritesEnum.SAVE_SEARCH
              );
            }
            return true; // no filtering when enableSoldReturn = false
          })
          .map((item: any, index: number) => renderTabItem(item, index, false))}
      </RightTabsContainer>
    </Container>
  );
};

const Container = styled.View<{ backgroundColor: string }>`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }: { theme: DefaultTheme }) =>
    theme["core-03"]};
  background-color: ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor};
  padding: 0 16px;
  height: 56px;
`;

const LeftTabsContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

const RightTabsContainer = styled.View`
  flex-direction: row;
`;

const CheckboxSectionContainer = styled.View`
  flex-direction: row;
  align-items: center;
  margin-left: 16px;
`;

const ItemContainer = styled.View`
  align-items: center;
  justify-content: center;
  margin: 4px;
`;

const CardMain = styled.View<any>`
  padding: 4px 8px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({
    theme,
    isFocused,
  }: {
    theme: DefaultTheme;
    isFocused: boolean;
  }) => (isFocused ? theme["core-02"] : theme["core-01"])};
  border-radius: 8px;
`;

const CardMainMenu = styled.View<any>`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({
    theme,
    isFocused,
  }: {
    theme: DefaultTheme;
    isFocused: boolean;
  }) => (isFocused ? theme["core-02"] : theme["core-01"])};
  border-radius: 8px;
  padding: 4px 8px;
`;

const TabContent = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const TabText = styled(VDBText)`
  margin-left: 4px;
`;

const HorizontalSeparator = styled.View`
  height: 24px;
  width: 1px;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-03"]};
  margin: 0 12px;
`;

const LineView = styled.View<any>`
  height: 1px;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-03"]};
  width: auto;
`;

const IconLabelWrapper = styled.View`
  border-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-05"]};
  flex-direction: row;
  align-items: center;
`;

const CheckIconWrapper = styled.View``;

const MenuItemContainer = styled.View`
  flex-direction: row;
  align-items: center;
  padding: 12px;
  width: 277px;
  justify-content: space-between;
`;

const MenuItemParentContainer = styled.View`
  width: 277px;
`;

const RedIconContainer = styled.View<any>`
  position: absolute;
  align-self: flex-end;
  height: 8px;
  width: 8px;
  border-radius: 4px;
  border-width: 1px;
  background-color: ${({ theme }: { theme: DefaultTheme }) =>
    theme["error-01"]};
  border-color: ${({ theme }: { theme: DefaultTheme }) => theme["cont-00"]};
`;

const ResetAllButton = styled(TouchableOpacity)`
  padding: 4px 8px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-01"]};
  border-radius: 8px;
`;

const LeftWrapper = styled.View<{ containerWidth: number }>`
  width: ${({ containerWidth }: { containerWidth: number }) => containerWidth};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const IconContainer = styled.View``;

export default memo(CustomTopTabsWeb);
